export default {
  ADMINISTRATOR: 'Administrator',
  KPC_SUPERVISOR: 'Kpc supervisor',
  KPC_EMPLOYEE: 'Kpc employee',
  EXTERNAL_SUPERVISOR: 'External supervisor',
  EXTERNAL_EMPLOYEE: 'External employee',
  OPERATOR247: 'Operator247',

};
